module.exports = __webpack_public_path__ + "static/icon_uber-109d510acc2a232ad982c8bb284c8d7f.png";